export const PRZELEWY24_PAYMENT_METHOD: string = "PRZELEWY24";